import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
let token = {
    state: {
        token: 'VrMakerToken',
        // isLogin: false,
    },
    mutations: {
        setToken: (state, token) => {
            state.token = token
            // state.isLogin = true
        }
    },
    actions: {},
    getters: {},

}
let proproT = {
    state: {
        AllId: 4
    },
    mutations: {

    },
    actions: {},
    getters: {},

}

let mqtt = {
    state: {
        all: {},
        alarm: {},
        max: {},
        mean: {},
        min: {}
    },
    mutations: {
        addMqttVal: (state, data) => {
            Vue.set(state.all, data.key, data.val)
        },
        addAlarm: (state, data) => {
            Vue.set(state.alarm, data.key, data.val)
        }

    },
    actions: {
        asyncAddMqttVal: ({
            state
        }, data) => {
            Vue.set(state.all, data.key, data.val)
        },
        addMqttValList: ({
            state
        }, list) => {
            list.forEach(data => {
                let key = data.key;
                let value = data.val;
                Vue.set(state.all, key, value)

                let current = state.max[key];
                if (current && current.val !== 0) {
                    if (current < value) {
                        Vue.set(state.max, key, {
                            val: value,
                            time: new Date()
                        })
                    }
                } else {
                    Vue.set(state.max, key, {
                        val: value,
                        time: new Date()
                    })
                }


                let currentMean = state.mean[key];
                if (currentMean) {
                    currentMean.val = (currentMean.val * currentMean.n + value) / (currentMean.n + 1)
                    currentMean.n = currentMean.n + 1
                } else {
                    Vue.set(state.mean, key, {
                        val: value,
                        n: 1
                    })
                }

                let currentMin = state.min[key]
                if (currentMin && currentMin.val !== 0) {
                    if (currentMin.val > value) {
                        Vue.set(state.min, key, {
                            val: value,
                            time: new Date()
                        })
                    }
                } else {
                    Vue.set(state.min, key, {
                        val: value,
                        time: new Date()
                    })
                }

            })
        }
    },
    getters: {
        mqttMinVal: state => key => state.min[key],
        mqttMeanVal: state => key => state.mean[key],
        mqttMaxVal: state => key => state.max[key],
        mqttVal: state => key => state.all[key],
        isAlarm: state => (loop, node) => {
            let alarmElement = state.alarm[`/${loop.subLoopUrl}/alarm/${node}`];
            if (alarmElement === undefined) {
                return false
            } else {
                return !alarmElement
            }
        }
    },
}
let subLoopUrl = {
    state: {
        LoopUrl: "eqweqwe",
        Loop: "LT001",
        valuer: "",
        getstatus: "qeqweqwe",
        //存储值
        loopName: "",
        //高度
        Top:''
    },
    mutations: {
        MutLoopUrl(state, LoopUrl) {
            state.LoopUrl = LoopUrl
        },
        LoopUrlTS(state, Loop) {
            state.Loop = Loop
        },
        changeValue(state, newVal) {
            state.valuer = newVal
        },
        statuLoop(state, getstatus) {
            state.getstatus = getstatus
        },
        loopNameSet(state, loopName) {
            state.loopName = loopName
        },
        scrollTop(state, Top) {
            state.Top = Top
        }
    },
    actions: {},
    getters: {},

}
export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        token,
        proproT,
        mqtt,
        subLoopUrl
    }
})